module.exports = __webpack_public_path__ + "static/img/1-2.863146d1.png";